<template>
 <v-app-bar app height="75">
    
    <v-toolbar flat >
      <v-toolbar-title class="hidden-md-and-down">
        <v-avatar class="mr-5 ml-5" size="65">
            <img src="/jetlightlogo.png" />
        </v-avatar>
        <span class="font-weight-bold mr-1 title">JetLight</span>
        <span class="title mr-16 ">Studio</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      
          <v-btn-toggle flat active-class="blue--text" style="background-color:#262626; ">
       <v-btn text class=" mr-10 subheading font-weight-bold" :x-small="$vuetify.breakpoint.smAndDown" :class="{'caption font-weight-bold': $vuetify.breakpoint.smAndDown}"
           @click="$vuetify.goTo('#home',options)" style="border:none;">Home</v-btn>
          <v-btn text class=" mr-10 subheading font-weight-bold" :x-small="$vuetify.breakpoint.smAndDown" :class="{'caption font-weight-bold': $vuetify.breakpoint.smAndDown}"
           @click="$vuetify.goTo('#services',options)" style="border:none;">Services</v-btn>
           <v-btn text class=" mr-10 subheading font-weight-bold" :x-small="$vuetify.breakpoint.smAndDown" :class="{'caption font-weight-bold': $vuetify.breakpoint.smAndDown}"
           @click="$vuetify.goTo('#portfolio',options)" style="border:none;">Portfolio</v-btn>
           <v-btn text class=" mr-10 subheading font-weight-bold" :x-small="$vuetify.breakpoint.smAndDown" :class="{'caption font-weight-bold': $vuetify.breakpoint.smAndDown}"
           @click="$vuetify.goTo('#team',options)" style="border:none;">Team</v-btn>
           <v-btn text class=" mr-10 subheading font-weight-bold" :x-small="$vuetify.breakpoint.smAndDown" :class="{'caption font-weight-bold': $vuetify.breakpoint.smAndDown}"
           @click="$vuetify.goTo('#testimonial',options)" style="border:none;">Testimonial</v-btn>
           <v-btn text class=" mr-2 subheading font-weight-bold" :x-small="$vuetify.breakpoint.smAndDown" :class="{'caption font-weight-bold': $vuetify.breakpoint.smAndDown}"
           @click="$vuetify.goTo('#contact',options)" style="border:none;">Contact</v-btn>
          </v-btn-toggle>
  
  
    
    </v-toolbar>
  </v-app-bar>
</template>
<script>

export default {
  data() {
    return {
      drawer: false,
      options: {
        duration: 1500,
        offset: 0,
        easing: "easeInOutCubic"
      },
    };
    
  },
};
</script>

